import logoShopifyOfficial from '@/assets/icons/logo-shopify-official.svg';
import logoNuvemshopOfficial from '@/assets/icons/logo-nuvemshop-official.png';

// Official full logo lockups (mark + wordmark, in each brand's own
// typography), not just a recolored glyph:
// - Shopify: the bag mark + "shopify" wordmark, sourced from Shopify's own
//   cdn.shopify.com brochure assets (official two-tone green, #95BF47 /
//   #5E8E3E — see logo-shopify-official.svg for the source/licensing note).
// - Nuvemshop: their logo PNG served straight off their own site
//   (app-insti-cdn.nuvemshop.com.br), already in the correct brand blue —
//   pixel-sampled as #0050C3 (their current "Science Blue", not the
//   outdated Cerulean #029CDC this page used before).
export const ONBOARDING_PLATFORM_OPTIONS = [
  {
    id: 'shopify',
    label: 'Shopify',
    logo: logoShopifyOfficial,
    color: '#95BF47',
  },
  {
    id: 'nuvemshop',
    label: 'Nuvemshop',
    logo: logoNuvemshopOfficial,
    color: '#0050C3',
    // Nuvemshop's official asset ships on a light-blue backdrop (unlike
    // Shopify's, which is transparent); the PNG here has that backdrop
    // cut out (color-keyed, not just cropped — see logo-nuvemshop-official
    // in asset history) so it's transparent like Shopify's, and the same
    // color (pixel-sampled as #F2F9FF from the original) is applied as the
    // card's own background instead — matching the brand's own logo
    // presentation without a second, separately-rendered rectangle that
    // could visibly seam against the card or sit behind the selected-check
    // badge.
    cardBackground: '#F2F9FF',
  },
];
